// this file is automatically generated by git.revision.js script
export const versions = { revision: '8143ede48b' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '8143ede48b';
